import { useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import { Form, Select } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import ModalCustom from '../../../Components/Modal/ModalCustom';
import RemoveModal from '../../../Components/Modal/RemoveModal';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useRole } from '../../../Hooks/Role';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { getApiUrl } from '../../../Utils/Helpers';
import { getToken } from '../../../Utils/Token';
import { CompetitionContext } from '../Context/CompetitionContext';

const CompetitionRegister = () => {
  const { can } = useRole();
  const { get, destroy } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [parseParams, setParseParams] = useState({});
  const navigate = useNavigate();
  const [filterModal, setFilterModal] = useState(false);
  const [excelExportModal, setExcelExportModal] = useState(false);
  const context = useContext(CompetitionContext);

  useEffect(() => {
    const getData = async () => {
      const params = queryString.parse(search);
      setParseParams(params);
      await getCompetitionRegisters();
      if (can('Super Admin') && params?.competition_id !== undefined) {
        await getCompetition(params?.competition_id);
      }
      await getProvinces();
    };

    getData();
  }, [search]);
  const getProvinces = async () => {
    setLoading(true);
    await get(
      '/province',
      (res) => {
        let data = [];
        data.push({
          id: 0,
          name: 'همه',
        });
        data.push(...res.data);
        context.provinces = data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };
  const getCompetition = async (competition_id) => {
    setLoading(true);
    await get(
      `/competition/${competition_id}`,
      (res) => {
        const { data } = res;
        let all = {
          id: 0,
          title: 'همه',
        };
        let sports = [];
        sports.push(all);
        sports.push(...data?.sports);
        data.sports = sports;

        let weights = [];
        weights.push({
          id: 0,
          weight: 'همه',
        });
        weights.push(...data?.weights);
        data.weights = weights;

        context.competition = data;
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };
  const getCompetitionRegisters = async (remove = false) => {
    setLoading(true);
    await get(
      `/competition-register${search}`,
      (res) => {
        context.competitionRegisters = res;
        if (remove) {
          setLoading(false);
        }
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const removeItem = async (id) => {
    setRemoveLoading(true);

    await destroy(
      `/competition-register/${id}`,
      (res) => {
        success(`حذف با موفقیت انجام شد`);
        setRemoveLoading(false);
        setModalIsOpen(false);
        getCompetitionRegisters(true);
      },
      (err) => {
        console.log(err);
        if (err?.status === 422) {
          error(err?.data?.data?.error);
        } else {
          error('حذف به علت خطا انجام نشد.');
        }
        setRemoveLoading(false);
      },
    );
  };

  const competitionRegisterFilter = (values, setSubmiting) => {
    let regexPaginate = new RegExp(/page=([0-9]+)/);
    let regexCompetitionId = new RegExp(/competition_id=([0-9]+)/);
    let pageExists = regexPaginate.test(search);
    let competitionIdExists = regexCompetitionId.test(search);
    let paginate = parseParams?.page;
    let competitionId = parseParams?.competition_id;

    let filter =
      pageExists && competitionIdExists
        ? `?page=${paginate}&competition_id=${competitionId}`
        : pageExists && !competitionIdExists
        ? `?page=${paginate}`
        : !pageExists && competitionIdExists
        ? `?competition_id=${competitionId}`
        : '';

    Object.entries(values).forEach((item) => {
      if (item[1] != 0 || item[1]?.length > 0) {
        filter +=
          filter.length > 0
            ? `&${item[0]}=${item[1]}`
            : `?${item[0]}=${item[1]}`;
      }
    });
    navigate(`/competition/competition-register${filter}`);
    setFilterModal(false);
  };
  const onExcelExport = (values) => {
    let filter = `?token=${getToken()}`;
    Object.entries(values).forEach((item) => {
      if (item[1] != 0 || item[1]?.length > 0) {
        filter +=
          filter.length > 0
            ? `&${item[0]}=${item[1]}`
            : `?${item[0]}=${item[1]}`;
      }
    });
    window.location.href = `${getApiUrl()}/report/competition/${
      parseParams?.competition_id
    }/excel${filter}`;
  };

  const onAgentExcelExport = () => {
    window.location.href = `${getApiUrl()}/report/competition/${
      parseParams?.competition_id
    }/excel/agent?token=${getToken()}`;
  };
  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title='لیست مسابقات ثبت نام شده'
          showBackBtn={false}
          showCreateBtn={false}
          showFilterBtn={true}
          filter={() => setFilterModal(true)}
          showExcelBtn={can('Super Admin')}
          onExcelExport={() => setExcelExportModal(true)}
          headerComponent={
            can('Super Admin') && (
              <div className='d-flex flex-row align-items-center mx-2'>
                <button
                  onClick={onAgentExcelExport}
                  className='d-flex flex-row align-items-center btn btn-outline-info'
                >
                  <i className='far fa-file-excel f-16 mx-2'></i>
                  <span className='f-13'>خروجی اکسل عوامل اجرایی</span>
                </button>
              </div>
            )
          }
        />
        {loading
          ? null
          : can('Super Admin') && (
              <div className='row'>
                <div className='col-12 col-md-3'>
                  {' '}
                  <div className='d-flex flex-row justify-items-center my-3'>
                    <span className='text-dark f-15 font-weight-bold'>
                      تعداد نتیجه :{' '}
                    </span>
                    <span className='text-dark f-15 font-weight-bold mx-2'>
                      {context.competitionRegisters?.meta?.pagination?.total ??
                        0}
                    </span>
                  </div>
                </div>
                <div className='col-12 col-md-3'>
                  <div className='d-flex flex-row justify-items-center my-3'>
                    <span className='text-dark f-15 font-weight-bold'>
                      تعداد ثبت نام انفرادی :{' '}
                    </span>
                    <span className='text-dark f-15 font-weight-bold mx-2'>
                      {context.competition?.users_length ?? 0}
                    </span>
                  </div>
                </div>
                <div className='col-12 col-md-3'>
                  <div className='d-flex flex-row justify-items-center my-3'>
                    <span className='text-dark f-15 font-weight-bold'>
                      تعداد تیم ثبت نام شده :{' '}
                    </span>
                    <span className='text-dark f-15 font-weight-bold mx-2'>
                      {context.competition?.teams_length ?? 0}
                    </span>
                  </div>
                </div>
                <div className='col-12 col-md-3'>
                  <div className='d-flex flex-row justify-items-center my-3'>
                    <span className='text-dark f-15 font-weight-bold'>
                      تعداد تیم ثبت نام شده لیگ :{' '}
                    </span>
                    <span className='text-dark f-15 font-weight-bold mx-2'>
                      {context.competition?.leagues_length ?? 0}
                    </span>
                  </div>
                </div>
                <div className='col-12 col-md-3'>
                  <div className='d-flex flex-row justify-items-center my-3'>
                    <span className='text-dark f-15 font-weight-bold'>
                      تعداد کل مربیان :{' '}
                    </span>
                    <span className='text-dark f-15 font-weight-bold mx-2'>
                      {context.competition?.coaches_length ?? 0}
                    </span>
                  </div>
                </div>
                <div className='col-12 col-md-3'>
                  <div className='d-flex flex-row justify-items-center my-3'>
                    <span className='text-dark f-15 font-weight-bold'>
                      تعداد کل سرپرست ها :{' '}
                    </span>
                    <span className='text-dark f-15 font-weight-bold mx-2'>
                      {context.competition?.supervisor_length ?? 0}
                    </span>
                  </div>
                </div>
              </div>
            )}

        <Datatable
          data={context.competitionRegisters?.data}
          editUrl='/competition/register'
          editParametr='competition.slug'
          editQueryParameters={['competition_register', 'id']}
          disabledEditRemoveIf={(item) =>
            (moment(item?.competition?.end_register_at).isBefore(moment()) ||
              moment(item?.competition?.start_register_at).isAfter(moment())) &&
            !can('Super Admin')
          }
          meta={context.competitionRegisters?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          basePagePath='/competition/competition-register'
          columns={[
            'استان',
            'عنوان',
            'شروع مسابقه',
            'پایان مسابقه',
            'لیست انفرادی',
            'تعداد انفرادی',
            'لیست تیمی',
            'تعداد تیم',
            'تعداد ورزشکاران تیم',
            'لیست لیگ',
            'تعداد لیگ',
            'تعداد ورزشکاران لیگ',
            'لیست مربیان',
            'تعداد مربیان',
            'لیست سرپست ها',
            'تعداد سرپست ها',
          ]}
          rows={[
            {
              name: 'province.name',
              type: 'relation',
              relType: 'string',
            },
            { name: 'competition.title', type: 'relation', relType: 'string' },
            {
              name: 'competition.start_register_at',
              type: 'relation',
              relType: 'date',
            },
            {
              name: 'competition.end_register_at',
              type: 'relation',
              relType: 'date',
            },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'مشاهده',
              link: '/competition-register/{id}/user',
              params: ['id'],
            },
            {
              name: 'users',
              type: 'length',
            },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'مشاهده',
              link: '/competition-register/{id}/team',
              params: ['id'],
            },
            {
              name: 'teams',
              type: 'length',
            },
            {
              name: 'teams.users',
              type: 'relLength',
            },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'مشاهده',
              link: '/competition-register/{id}/league',
              params: ['id'],
            },
            {
              name: 'leagues',
              type: 'length',
            },
            {
              name: 'leagues.users',
              type: 'relLength',
            },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'مشاهده',
              link: '/competition-register/{id}/coach',
              params: ['id'],
            },
            {
              name: 'coaches',
              type: 'length',
            },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'مشاهده',
              link: '/competition-register/{id}/supervisor',
              params: ['id'],
            },
            {
              name: 'supervisors',
              type: 'length',
            },
          ]}
        />
      </Master>
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalIsOpen}
        removeItem={removeItem}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف از مسابقه 
        مطمئن هستید ؟
        در صورت حذف امکان بازگشت وجئد ندارد.
        `}
      />

      <ModalCustom modalIsOpen={filterModal}>
        <div className='d-flex flex-row justify-content-between align-items-center border-bottom pb-2'>
          <span className=''>فیلتر مسابقات</span>
          <i
            className='far fa-times text-white f-20 mx-2 c-pointer'
            onClick={() => setFilterModal(false)}
          ></i>
        </div>
        <div className='w-100 my-3'>
          <Form
            initialValues={{
              province_id: parseParams?.province_id ?? 0,
            }}
            defaultActions={false}
            onSubmit={competitionRegisterFilter}
          >
            <div className='row'>
              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='استان'
                  options={context.provinces}
                  name='province_id'
                  optionLabel='name'
                  optionValue='id'
                />
              </div>

              <div className='col-12 d-flex flex-row justify-content-center align-items-center'>
                <span
                  className='btn px-5 btn-danger text-white f-12 my-3 mx-2 c-pointer'
                  onClick={() => setFilterModal(false)}
                >
                  انصراف
                </span>
                <button className='btn px-5 btn-info text-white f-12 my-3'>
                  فیلتر
                </button>
              </div>
            </div>
          </Form>
        </div>
      </ModalCustom>

      <ModalCustom modalIsOpen={excelExportModal}>
        <div className='d-flex flex-row justify-content-between align-items-center border-bottom pb-2'>
          <span className=''>خروجی اکسل</span>
          <i
            className='far fa-times text-white f-20 mx-2 c-pointer'
            onClick={() => setExcelExportModal(false)}
          ></i>
        </div>
        <div className='w-100 my-3'>
          <Form
            initialValues={{
              sport_id: 0,
              weight_id: 0,
              type: 1,
            }}
            defaultActions={false}
            onSubmit={onExcelExport}
          >
            <div className='row'>
              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='رشته'
                  options={context.competition?.sports}
                  name='sport_id'
                  optionLabel='title'
                  optionValue='id'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='وزن'
                  options={context.competition?.weights}
                  name='weight_id'
                  optionLabel='weight'
                  optionValue='id'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='نوع خروجی'
                  options={context.competition?.type}
                  name='type'
                  optionLabel='title'
                  optionValue='id'
                />
              </div>
              <div className='col-12 d-flex flex-row justify-content-center align-items-center'>
                <span
                  className='btn px-5 btn-danger text-white f-12 my-3 mx-2 c-pointer'
                  onClick={() => setExcelExportModal(false)}
                >
                  انصراف
                </span>
                <button className='btn px-5 btn-info text-white f-12 my-3'>
                  خروجی اکسل
                </button>
              </div>
            </div>
          </Form>
        </div>
      </ModalCustom>
    </>
  );
};

export default CompetitionRegister;
